


















import { Component, Mixins, Prop } from 'vue-property-decorator'
import { ApiGeneralObjectArrayPayload, ApiGeneralSinglePayload } from '@/tcw/api/types'
import BaseComponent from '@/tcw/components/BaseComponent'
import { TcwFormDate } from '@/tcw/domain/types'

@Component
export default class ShouninLocalHeader extends Mixins(BaseComponent) {
  @Prop({
    default: () => {
      /** */
    }
  })
  protected teishutsu!: ApiGeneralSinglePayload

  get teishutsuGetsudoDate(): TcwFormDate {
    if (typeof this.teishutsu?.teishutsuGetsudo === 'string') {
      return this.tcw.dateOf(this.teishutsu.teishutsuGetsudo)
    } else {
      return this.du.now()
    }
  }
  get shouninUserList(): ApiGeneralObjectArrayPayload {
    return Array.isArray(this.teishutsu?.shouninUserList)
      ? (this.teishutsu.shouninUserList as ApiGeneralObjectArrayPayload)
      : []
  }
  get getsudoStr(): string {
    return this.du.convertDateToStr(this.teishutsuGetsudoDate, 'YYYY年MM月度')
  }
  get shouninUserNameList(): string {
    return this.shouninUserList.map((user: ApiGeneralSinglePayload) => user.userName).join(',')
  }
  get hasBall(): boolean {
    return this.shouninUserList.some(user => user.id === this.loginUserId)
  }
}
